const PUBLIC_FORM_REPORT_KEY_PATTERN = /^public-form:([1-9][0-9]*)$/;

export const publicFormIdFromReport = (report) => {
  if (!report || report.report_type !== 'public_form' || report.immutable !== true) return null;
  const id = String(report.id ?? '');
  const reportKey = String(report.report_key ?? '');
  const match = id.match(PUBLIC_FORM_REPORT_KEY_PATTERN);
  if (!match || reportKey !== id || String(report.public_form_id ?? '') !== match[1]) return null;
  const formId = Number(match[1]);
  return Number.isSafeInteger(formId) ? formId : null;
};

export const isManagedPublicFormReport = (report) => publicFormIdFromReport(report) !== null;

export const buildManagedPublicFormReportRequest = (report, options = {}) => {
  if (!isManagedPublicFormReport(report)) return null;
  const request = {
    report_id: report.id,
    report_type: 'public_form',
    page: options.page,
    per_page: options.perPage,
    sort_by: options.sortBy ?? null,
    sort_direction: options.sortDirection ?? 'asc',
  };
  if (options.export === true) request.export = true;
  return request;
};
